export default function() {
	return navigator.userAgent.indexOf('Mobile Safari') !== -1
		|| navigator.userAgent.indexOf('Android') !== -1
		|| window.innerWidth < 1024;
}
